module.exports = __webpack_public_path__ + "4ef3f6014a2c527a42861e0ee1e34e85.png";